import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../../store';

export const selectBalanceState = createSelector(
  (state: RootState) => state.balance,
  (clients) => clients
);

export const selectBalanceData = createSelector(
  selectBalanceState,
  (clientStatus) => clientStatus.data
);
